import AuditLogLink from './AuditLogLink';

export default AuditLogLink;
